import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

export default function VideoPlaceholder({ width, height, onClick }) {
    return (
        <Box
            onClick={onClick}
            sx={{
                position: 'relative',
                width: width || 250,
                height: height || 150,
                backgroundColor: 'grey.300',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 1,
            }}>
            <Box
                data-testid="play-button"
                sx={{
                    position: 'absolute',
                    color: 'common.white',
                    backgroundColor: 'grey.700',
                    borderRadius: '50%',
                    width: 50,
                    height: 50,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: 'grey.800',
                    },
                }}>
                <PlayArrowIcon fontSize="large" />
            </Box>
        </Box>
    );
}

VideoPlaceholder.propTypes = {
    width: PropTypes.number, // Width of the video placeholder (optional)
    height: PropTypes.number, // Height of the video placeholder (optional)
    onClick: PropTypes.func.isRequired, // Function to handle click events (required)
};
